"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
exports.defaultConfig = {
    maxMessagesBulk: 5,
    sendingInterval: 1000 * 20, // every 20 seconds
};
